module.exports = __webpack_public_path__ + "img/section5_pic1@2x.e2f6ea47.png";